


















import { Component, Vue } from 'vue-property-decorator';
import BottomNav from './BottomNav.vue';

// mixins
import MyHomeMixins from './MixinsFunc/MyHomeMixins'; 
// 声明组件*****************
@Component({
  components: {
      BottomNav
  },
  mixins: [MyHomeMixins]
})
export default class CommunityFire extends Vue {
  // 属性*****************
  private userDataOk: number = -2;
  async mounted () {
    const status = await this['getUserInfo']();
    this.userDataOk = status;
  }
  // 方法*****************
  
}
